import { createSvgIcon } from "@mui/material/utils";
import React from "react";

const IconRadioChecked = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0052 20C15.4719 20 20 15.4719 20 9.99484C20 4.52811 15.4616 0 9.99484 0C4.52811 0 0 4.52811 0 9.99484C0 15.4719 4.53842 20 10.0052 20Z"
      fill="currentColor"
    />
    <path
      d="M10.0025 13.6365C11.9904 13.6365 13.637 11.9899 13.637 9.99826C13.637 8.01035 11.9866 6.36377 9.99875 6.36377C8.01084 6.36377 6.36426 8.01035 6.36426 9.99826C6.36426 11.9899 8.01459 13.6365 10.0025 13.6365Z"
      fill="white"
    />
  </svg>,
  "IconRadioChecked",
);

export default IconRadioChecked;
